<div class="feed-upload-dialog">
  <h2>Upload Legal Mining Area File</h2>

  <div
    class="upload-box"
    tabindex="0"
    role="button"
    aria-label="Upload GeoJSON, KML, or KMZ"
    [class.dragover]="isDragOver"
    [class.loading]="isParsingFile"
    (click)="fileInput.click()"
    (keydown.enter)="fileInput.click()"
    (keydown.space)="$event.preventDefault(); fileInput.click()"
    (drop)="onFileDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
  >
    <ng-container *ngIf="!isParsingFile; else uploadLoader">
      <span class="material-icons upload-icon" aria-hidden="true">cloud_upload</span>
      <div class="upload-title">Drag &amp; Drop GeoJSON, KML, or KMZ file here</div>
      <div class="upload-browse">or browse files</div>
      <div class="upload-helper">GeoJSON, KML, or KMZ - Max file size: 5MB</div>
    </ng-container>

    <ng-template #uploadLoader>
      <span class="upload-spinner" aria-hidden="true"></span>
      <div class="upload-title">Uploading file...</div>
    </ng-template>

    <input
      #fileInput
      type="file"
      hidden
      accept=".geojson,.json,.kml,.kmz,application/geo+json,application/json,application/vnd.google-earth.kml+xml,application/vnd.google-earth.kmz"
      [disabled]="isParsingFile || isSubmitting"
      (change)="onFileSelected($event)"
    />
  </div>

  <div class="uploaded-file" *ngIf="selectedFile">
    <div class="file-left">
      <span class="material-icons file-icon" aria-hidden="true">description</span>
      <div class="file-info">
        <div class="file-name">{{ selectedFile.name }}</div>
        <div class="file-size">{{ selectedFileSizeLabel }}</div>
      </div>
    </div>

    <button
      type="button"
      class="remove-file"
      aria-label="Remove uploaded file"
      [disabled]="isParsingFile || isSubmitting"
      (click)="removeFile(fileInput, $event)"
    >
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </div>

  <div *ngIf="fileError" class="inline-error">{{ fileError }}</div>

  <div class="btns">
    <button
      mat-stroke-button
      type="button"
      class="custom-button"
      [disabled]="isParsingFile || isSubmitting"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      type="button"
      class="submit"
      [disabled]="!selectedFile || !!fileError || isParsingFile || isSubmitting"
      (click)="submit()"
    >
      {{ isSubmitting ? 'Submitting...' : 'Submit' }}
    </button>
  </div>
</div>
